import React from 'react'

export default function ProgressLine() {
    return (
        <div style={{
            position: 'relative',
            height: '100vh',
            width: '100%',
            background: 'rgb(13,110,253,0.9)',
            zIndex: 99
        }}>

            <div style={{
                margin: 0,
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
            }}>
                <div className="spinner-grow text-light" role="status"
                    style={{
                        width: '3rem',
                        height: '3rem'
                    }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    )
}
